import { Component, input, model, output } from "@angular/core";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { TagModule } from "primeng/tag";
import { DividerModule } from "primeng/divider";
import { CardModule } from "primeng/card";
import { AvatarModule } from "primeng/avatar";
import { DatePipe, TitleCasePipe } from "@angular/common";
import { IPartner } from "../../../../Utils/_models/partner.model";

@Component({
  selector: "app-partner-view",
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    TagModule,
    DividerModule,
    CardModule,
    AvatarModule,
    DatePipe,
    TitleCasePipe
  ],
  templateUrl: "./partner-view.component.html",
  styleUrl: "./partner-view.component.css",
})
export class PartnerViewComponent {
  partner = input<IPartner>();
  visible = model<boolean>(false);
  onClose = output();

  getInitials(name?: string): string {
    if (!name) return "N/A";
    return name
      .split(" ")
      .map(n => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  }

  getStatusSeverity(status: string): string {
    const severityMap: Record<string, string> = {
      approved: "p-tag-success",
      pending: "p-tag-warning",
      rejected: "p-tag-danger",
      under_review: "p-tag-info",
    };

    return severityMap[status.toLowerCase()] || "p-tag-secondary";
  }

  getKycSeverity(status: string): string {
    const severityMap: Record<string, string> = {
      verified: "p-tag-success",
      pending: "p-tag-warning",
      failed: "p-tag-danger",
      not_started: "p-tag-secondary",
    };

    return severityMap[status.toLowerCase()] || "p-tag-secondary";
  }

  closeDialog(): void {
    this.onClose.emit();
  }
}
